import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { get as _get } from 'lodash';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Store
import { PolicySelectors } from '@amfam/policy/data-access';
import { Policy } from '@amfam/policy/models';
import { AnalyticsFacade, PageAnalyticParams } from '@amfam/shared/analytics';
import { userQuery, UserState } from '@amfam/shared/user';

import * as fromRoot from '../../../core/store';
import { GoPaperlessModel } from './go-paperless.model';

@Directive()
export abstract class GoPaperlessComponentDirective implements OnInit, OnDestroy {
  private policySubscription$: Observable<Policy[]>;
  private stop$: Subject<void> = new Subject<void>();

  models: GoPaperlessModel[] = new Array<GoPaperlessModel>();
  protected policies: Policy[] = new Array<Policy>();
  user: UserState;

  // **** Start of Analytics data for this component
  protected errorAnalytic: PageAnalyticParams = {
    pageName: 'MyAccount:Enroll:Paperless:Error',
    experience: '',
    primaryCategory: 'My Account',
    subCategory1: 'Policies',
    subCategory2: 'Go Paperless',
    subCategory3: ''
  };
  // **** End of Analytics data for this component

  constructor(
    protected store: Store<fromRoot.RootState>,
    protected analyticsFacade: AnalyticsFacade
  ) {}

  ngOnInit() {
    this.policySubscription$ = this.store.select(PolicySelectors.selectAdvancePolicies);
    this.policySubscription$.pipe(takeUntil(this.stop$)).subscribe(
      policies => {
        if (policies) {
          this.models = policies.map(policy => new GoPaperlessModel(policy));
          this.policies = policies;
        }
      },
      err => {
        this.analyticsFacade.trackPageAndError(this.errorAnalytic, 'PolicyLoadError');
        throw err;
      }
    );
    this.store
      .select(userQuery.selectUserState)
      .pipe(takeUntil(this.stop$))
      .subscribe(user => {
        this.user = user;
      });
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }

  getMyAccountEmailAddress() {
    return _get(this.user, 'emailAddress', '');
  }
}
